import React, { useState } from "react";
import Drawer from "../../../../components/SideDrawer/SideDrawer";
import PlaygroundIcon from "../../../../assets/svg/playground-icon";
import CloseIcon from "../../../../assets/svg/close-icon";
import AddContentView from "./components/AddContentView";
import UploadDocuments from "./components/UploadDocuments";
import Button from "../../../../components/Button/Button";
import ArrowRightIcon from "../../../../assets/svg/arrow-right-icon";

import AddCustomQAContent from "./components/AddCustomQAContent";
import AddWebsite from "./components/AddWebsite";

const AddContentDrawer = ({
  open,
  onClose,
  setScrollToSection,
  properties,
}: {
  open: boolean;
  onClose: () => void;
  properties: { res: { name: string; id: string }[] };
  setScrollToSection?: (scrollToSection: string | null) => void;
}) => {
  const [selectedContentType, setSelectedContentType] = useState<string | null>(
    null,
  );
  const handleSelectContentType = (contentType: string) => {
    setSelectedContentType(contentType);
  };

  const handleClose = () => {
    setSelectedContentType(null);
    onClose();
  };

  return (
    <Drawer
      open={open}
      onClose={handleClose}
      direction="right"
      size="600px"
      overlayColor="rgba(0,0,0,0.7)"
      duration={300}
      closeOnOverlayClick={true}
      closeOnEscape={true}
      drawerContainerClassName="rounded-l-[8px]"
    >
      <div className="p-4.5 flex flex-col gap-2.5 h-full overflow-hidden">
        <div className="shrink-0 flex items-center justify-between">
          {selectedContentType === null ? (
            <PlaygroundIcon className="w-8.5 h-8.5 text-verba-blue dark:text-verba-blue-dk" />
          ) : (
            <Button
              innerText="Go Back"
              onClick={() => setSelectedContentType(null)}
              buttonContainerClass="justify-start"
              innerTextClass="text-md text-heading-text dark:text-heading-text-dk font-medium"
              iconLeft={true}
              Icon={ArrowRightIcon}
              iconClass="w-3.5 h-3.5 text-verba-indigo dark:text-verba-indigo-dk rotate-225"
            />
          )}
          <button
            className="w-[16px] h-[16px] bg-gray-100 dark:bg-gray-100-dk rounded-full flex flex-col items-center justify-center"
            aria-label="close create user modal"
            onClick={handleClose}
          >
            <CloseIcon className="w-[6px] h-[6px] text-verba-indigo dark:text-verba-indigo-dk" />
          </button>
        </div>
        <div className="flex-1 min-h-0 overflow-y-auto no-scrollbar">
          {selectedContentType === null ? (
            <AddContentView handleSelectContentType={handleSelectContentType} />
          ) : selectedContentType === "doc" ? (
            <UploadDocuments
              properties={properties}
              onClose={handleClose}
              setScrollToSection={setScrollToSection}
            />
          ) : selectedContentType === "website" ? (
            <AddWebsite
              onClose={handleClose}
              setScrollToWebsite={setScrollToSection}
            />
          ) : (
            <AddCustomQAContent onClose={handleClose} properties={properties} setScrollToSection={setScrollToSection} />
          )}
        </div>
      </div>
    </Drawer>
  );
};

export default AddContentDrawer;
